import * as Paginator from "react-bootstrap-table2-paginator";

import { Card, Col, Form, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit";
import { faPlus, faSearch, faSmile } from "@fortawesome/free-solid-svg-icons";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import {
  getCustomerEntry,
  getCustomerEntryByDate,
  getCustomerEntryExcelDownload,
  getCustomerLExcel,
  getCustomerPdfDownload,
  putCustomerEntry,
} from "../../Service/AllCustomerEntryAPI";
import { format } from 'date-fns';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Pagination from "react-bootstrap-table2-paginator";
import Table from "react-bootstrap-table-next";
import ToolTip from "../ToolTip";
import axios from "../../utils/axiosInstance";
import cellEditFactory from "react-bootstrap-table2-editor";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import fileSaver from "file-saver";
import moment from "moment";
import swal from "sweetalert";

export default () => {
  const [entries, setEntries] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [type, setType] = useState("customer");
  const [isLoaded, setisLoaded] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  // ----- Pagination
  const [currentPage, setcurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [totaloffset, setTotaloffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [changeRowData, setChangeRowData] = useState({
    selectedRow: [],
    cellChange: "",
    columnChange: [],
  });
  const handlePageChange = async (page) => {
    setEntries([]);
    const selectedPage = page - 1;
    console.log("selectedPage", selectedPage);
    if (fromDate === "" && toDate === "") {
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      await getCustomerEntry(selectedPage, headers)
        .then((result) => {
          console.log("Get Pagination Customer Result", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            const totalSize = result.data.pageable.offset;
            console.log("data", data);
            setEntries(data);
            setPageCount(result.data.totalPages);
            setTotaloffset(totalSize);
            entries.map((item, index) => (item.id = totalSize + index + 1));
          } else {
            setEntries([]);
            setPageCount();
            setTotalCount();
            swal("Sorry", "Customer data is not present", "warning");
          }
        })
        .catch((error) => console.error("Error", error));
    }
    // ----- Date wise pagination
    else if (fromDate !== "" && toDate !== "") {
      await getCustomerEntryByDate(
        selectedPage,
        moment(fromDate).format("yyyy-MM-DD"),
        moment(toDate).format("yyyy-MM-DD")
      )
        .then((result) => {
          console.log("Get Pagination Date wise Customer Result", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            const totalSize = result.data.pageable.offset;
            entries.map((item, index) => (item.id = totalSize + index + 1));
            setEntries(data);
            setTotaloffset(totalSize);
            setTotalCount(result.data.totalElements);
          } else {
            setEntries([]);
            setPageCount();
            setTotalCount();

            swal(
              "Sorry",
              "Customer data is not present for selected date",
              "warning"
            );
          }
        })
        .catch((error) => {
          console.log("Get Field Issue Error", error);
        });
      setisLoaded(false);
    } else {
      swal("Failed", "Please select date", "error");
    }
  };
  useEffect(() => {
    // ----- Function call to update customer details
    putCustomerDetailsChange();
    // eslint-disable-next-line
  }, [changeRowData]);

  useEffect(() => {
    // ----- Function call to get customer list
    getCustomerList();
    // eslint-disable-next-line
  }, []);



  // ----- Function declaration of get customer list
  const getCustomerList = async () => {
    try {
      setTimeout(async () => {
        const token = sessionStorage.getItem("token");
        const headers = { Authorization: `Bearer ${token}` };
        setisLoaded(true);
        await getCustomerEntry(currentPage, headers)
          .then((result) => {

            console.log("Get Customer Result", result);
            if (result?.data?.content?.length !== 0) {
              const data = result.data.content;
              setEntries(data);
              setPageCount(result.data.totalPages);
              setTotalCount(result.data.totalElements);

            } else {
              setEntries([]);
              setPageCount();
              setTotalCount();
              swal("Sorry", "Customer data is not present.", "warning");

            }
          })
          .catch((error) => {
            console.log("Get Dispatch Error", error);
          });
        setisLoaded(false);
      }, 200);
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };


  const handleFromDateChange = (date) => {
    setFromDate(date);
    // Clear the "To" date if it's before the selected "From" date
    if (toDate && date > toDate) {
      setToDate(null);
    }
  };

  // Handle the "To" date change
  const handleToDateChange = (date) => {
    if (date < fromDate) {
      swal('Invalid Date', 'The "To" date cannot be before the "From" date.', 'warning');
      setToDate(null); // Reset "To" date if invalid
    } else {
      setToDate(date);
    }
  };


  /**
   * Function declaration for setting fromDate on "fromDate" input field change event
   * @param {*} e pass input field value
   */
  // const getCustomerListByFromDate = (e) => {
  //   const selectedDate = e.target.value;
  //   setFromDate(selectedDate);

  //   const formattedDate = format(new Date(selectedDate), 'dd-MMM-yyyy'); // Format the date here
  //   console.log("Formatted Date:", formattedDate);  // Log formatted date

  //   const today = new Date().toISOString().split("T")[0]; // Get today's date as string

  //   if (selectedDate > today) {
  //     swal("Sorry", "Please select today or a day before today", "warning");
  //   }
  // };

  // ----- Function declaration for setting toDate on "toDate" field change event
  // const getCustomerListByToDate = async (e) => {
  //   setToDate(e.target.value);
  //   console.log(toDate);
  //   if (e.target.value > new Date().toISOString().split("T")[0]) {
  //     swal("Sorry", "Please select today or day before today", "warning");
  //   }
  // };

  // ----- Function declaration for API call to get customer list by date on "Search By Date" button click event
  const getCustomerListByDate = async () => {
    try {
      setTimeout(async () => {
        setisLoaded(true);
        if (fromDate !== "" && toDate !== "") {

          await getCustomerEntryByDate(
            currentPage,
            moment(fromDate).format("yyyy-MM-DD"),
            moment(toDate).format("yyyy-MM-DD")
          )
            .then((result) => {
              console.log("Get Customer Entry Result", result);
              if (result?.data?.content?.length !== 0) {
                const data = result.data.content;
                setEntries(data);
                setPageCount(result.data.totalPages);
                setTotalCount(result.data.totalElements);
                setToDate("")
                setFromDate("")
              } else {
                setEntries([]);
                setPageCount();
                setTotalCount();

                swal(
                  "Sorry",
                  "Customer data is not present for selected date.",
                  "warning"
                );
              }
              // console.log("setNoOfElements", noOfElements);
            })
            .catch((error) => {
              console.log("Get Customer Entry Error", error);
            });
        } else {
          swal("Failed", "Please select date", "error");
        }
        setisLoaded(false);
      }, 200);
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };

  // ----- Function declaration to Download Customer Excel
  const getCustomerExcelDownload = async () => {
    if (fromDate !== "" && toDate !== "") {
      // ----- Excel by filtering date
      try {
        await getCustomerEntryExcelDownload(
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
        );
        setToDate("")
        setFromDate("")
      } catch (error) {
        console.log("getCustomerEntryExcelDownload error :-", error);
      }
    } else {
      // ----- complete Excel
      try {
        let result = await getCustomerLExcel();
        console.log("getUserLExcel result :-", result);
        setToDate("")
        setFromDate("")
        let blob = new Blob([result.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(blob, "customerList.xlsx");
      } catch (error) {
        console.log("getCustomerList error :-", error);
      }
    }
  };

  // ----- Function declaration to Download Customer Pdf
  const CustomerPdfDownload = async () => {
    try {
      // ----- Pdf by filtering date
      if (fromDate !== "" && toDate !== "") {
        setisLoaded(true);
        await getCustomerPdfDownload(
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
          
        );
        setisLoaded(false);
        setToDate("")
        setFromDate("")
      } else {
        setisLoaded(false);
        swal("Failed", "Please select date", "error");
      }
    } catch (error) {
      console.log(error);
      setisLoaded(false);
    }
  };

  // ----- Function declaration to update customer details
  const putCustomerDetailsChange = async () => {
    try {
      if (changeRowData?.selectedRow?.length !== 0) {
        // ----- Set selectedRow to edited row getting from child component
        const selectedRow = changeRowData.selectedRow;
        // ----- Set selectedRow's edited column with edited new value getting from child component
        selectedRow[changeRowData.columnChange] = changeRowData.cellChange;
        console.log("Change Customer row", selectedRow);
        const loginUserName = sessionStorage.getItem("userName");

        // ----- Object for update customer data
        const data = {
          pkCustomerId: selectedRow.pkCustomerId,
          customerName: selectedRow.customerName,
          customerEmailId: selectedRow.customerEmailId,
          customerMobileNo: selectedRow.customerMobileNo,
          customerAddress: selectedRow.customerAddress,
          contactPersonName: selectedRow.contactPersonName,
          contactEmailId: selectedRow.contactEmailId,
          contactPersonDesignation: selectedRow.contactPersonDesignation,
          contactPhoneNo: selectedRow.contactPhoneNo,
          country: selectedRow.country,
          state: selectedRow.state,
          city: selectedRow.city,
          siteName: selectedRow.siteName,
          pinCode: selectedRow.pinCode,
          discription: selectedRow.discription,
          userName: selectedRow.userName,
          password: selectedRow.password,
          role: selectedRow.role,
          status: selectedRow.status,
          createdOn: selectedRow.createdOn,
          createdBy: selectedRow.createdBy,
          modifiedBy: `${loginUserName}`,
        };
        console.log("Change Customer datails", data);
        await putCustomerEntry(data)
          .then((result) => {
            console.log("Customer Result", result);
          })
          .catch((error) => {
            console.log("Customer Error", error);
            swal("Failed", "Update Customer datails Failed", "error");
          });
      }
    } catch (error) {
      console.log(error);
    }
  };

  // ----- Adding SrNo column to list
  entries.map((item, index) => (item.id = totaloffset + index + 1));

  // ----- Column heading of Customer list
  const columns = [
    { dataField: "id", text: "Sr. No." },
    {
      dataField: "customerName",
      text: "Customer Name",
    },
    {
      dataField: "customerEmailId",
      text: "Registered Email",
    },
    {
      dataField: "createdOn",
      text: "Created Date",

      formatter: (cell) => {
        return <>{moment(cell).format("DD-MMM-YYYY")}</>;
      },
    },
    {
      dataField: "createdTime",
      text: "Created Time",
      formatter: (cell) => {
        const formattedTime = moment(cell, "hh:mm A", true);
        if (!formattedTime.isValid()) {
          return <>{'Invalid Time'}</>;
        }
        return <>{formattedTime.format("hh:mm A")}</>;
      },

    },
    {
      dataField: "customerMobileNo",
      text: "Registered Mobile No.",
    },
    {
      dataField: "userName",
      text: "Username",
    },
    {
      dataField: "contactPersonName",
      text: "Contact Person Name",
    },

    {
      dataField: "contactPersonDesignation",
      text: "Contact Designation",
    },
    {
      dataField: "contactEmailId",
      text: "Contact Email",
    },
    {
      dataField: "contactPhoneNo",
      text: "Contact Mobile No.",
    },
    {
      dataField: "discription",
      text: "Description",
      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell}</div>
          {cell.length > 20 && (
            <span className="tooltip-text">{row.discription}</span>
          )}
        </div>
      )
    },
    {
      dataField: "customerAddress",
      text: "Address",

      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell}</div>
          {cell.length > 20 && (
            <span className="tooltip-text">{row.customerAddress}</span>
          )}
        </div>
      )
    },
    {
      dataField: "country",
      text: "Country",
    },
    {
      dataField: "state",
      text: "State",
    },
    {
      dataField: "city",
      text: "City",
    },
    
    {
      dataField: "pinCode",
      text: "Pin Code",
    },
    {
      dataField: "siteName",
      text: "Site Name",
    },
    
  ];

  // ----- No. of Records to be displayed
  const customTotal = (from, to, size) => (
    <div>
      Showing {totaloffset + from} to {totaloffset + to} of {size} entries
    </div>
  );

  // ----- Implement startWith instead of contain
  function customMatchFunc({ searchText, value, column, row }) {
    if (typeof value !== "undefined") {
      return value.startsWith(searchText);
    }
    return false;
  }



  return (
    <>
      {isLoaded ? (
        <div className="reportload"></div>
      ) : (
        <>
          <Row>
            <Col md={{ span: 3, order: 1 }} className="mb-3" xs={{ order: 2 }}>
              <div className="form-group">
                <label>From Date</label>
                <DatePicker
                  selected={fromDate}
                  onChange={handleFromDateChange}
                  dateFormat="dd-MMM-yyyy" // Display format for the input
                  maxDate={new Date()} // Prevent selecting future dates
                  className="form-control"
                  placeholderText="DD-MMM-YYYY"// A more user-friendly placeholder
                  showYearDropdown // Add year dropdown for easier navigation
                  scrollableYearDropdown // Make year dropdown scrollable (for easier access to older years)
                />
              </div>
            </Col>
            <Col md={{ span: 3, order: 2 }} className="mb-3" xs={{ order: 3 }}>
              <div className="form-group">
                <label>To Date</label>
                <DatePicker
                  selected={toDate}
                  onChange={handleToDateChange}
                  dateFormat="dd-MMM-yyyy" // Display format for the input
                  minDate={fromDate} // "To" date should be equal to or later than "From" date
                  maxDate={new Date()} // Prevent selecting future dates
                  className="form-control"
                  placeholderText="DD-MMM-YYYY"
                  showYearDropdown // Add year dropdown for easier navigation
                  scrollableYearDropdown // Make year dropdown scrollable (for easier access to older years)
                />
              </div>
            </Col>
            <Col md={{ span: 3, order: 3 }} className="mb-3" xs={{ order: 4 }}>
              <button
                className="btn btn-secondary mt-lg-4"
                onClick={getCustomerListByDate}
              >
                <FontAwesomeIcon icon={faSearch} className="me-2" />
                <span>Search By Date</span>{" "}
              </button>
            </Col>
            <Col md={{ span: 3, order: 4 }} className="mt-4" xs={{ order: 1 }}>
              <div className="newadd" align="right">
                <Link className="btn btn-secondary" to="customer-entry">
                  <FontAwesomeIcon icon={faPlus} className="me-2" />
                  <span>Add Customer Entry</span>{" "}
                </Link>
              </div>
            </Col>
          </Row>

          <ToolkitProvider
            keyField="id"
            // search={true}
            columns={columns}
            data={entries}
            search={{ customMatchFunc }}
            exportCSV={{ onlyExportFiltered: true, exportAll: true }}
          >
            {({ baseProps, searchProps, csvProps }) => (
              <Paginator.PaginationProvider
                pagination={Pagination({
                  custom: true,
                  disablePageTitle: true,
                  alwaysShowAllBtns: true,
                  totalSize: totalCount,
                  paginationTotalRenderer: customTotal,
                  onPageChange: handlePageChange,
                })}
              >
                {({ paginationProps, paginationTableProps }) => (
                  <Card>
                    <div className="table-responsive py-2">
                      <Card.Header>
                        <Row>
                          <Col xs={12} md={6} className="py-1">
                          <h5 className="head mb-2">Customer Entry list</h5></Col>
                          <Col
                            xs={12}
                            md={6}
                            className="d-flex justify-content-md-end py-1"
                          >
                            <button
                              className="btn btn-secondary"
                              // ----- Function call to download customer pdf
                              onClick={CustomerPdfDownload}
                            >
                              <FontAwesomeIcon
                                icon={faDownload}
                                className="me-2"
                              />
                              <span>PDF</span>{" "}
                            </button>
                            <button
                              className="btn btn-secondary mx-2"
                              // ----- Function call to download customer excel
                              onClick={getCustomerExcelDownload}
                            >
                              <FontAwesomeIcon
                                icon={faDownload}
                                className="me-2"
                              />
                              <span>Excel</span>
                            </button>
                          </Col>
                        </Row>
                      </Card.Header>
                      <Table
                        {...baseProps}
                        {...paginationTableProps}
                        bodyClasses="border-0"
                        rowClasses="border-bottom"
                        classes="table-flush dataTable-table"
                        wrapperClasses="table-responsive"
                        filter={filterFactory()}
                        remote={{ pagination: true }}
                        headerClasses="header-class"
                        hover
                        striped
                        cellEdit={cellEditFactory({
                          mode: "click",
                          blurToSave: true,
                          afterSaveCell: (oldValue, newValue, row, column) => {
                            const changeRowData = {
                              selectedRow: row,
                              cellChange: newValue,
                              columnChange: column,
                            };
                            var newRowData = JSON.parse(
                              JSON.stringify(changeRowData)
                            );
                            setChangeRowData(newRowData);
                            return { async: true };
                          },
                        })}
                      // selectRow={selectRow}
                      />
                      <Card.Footer>
                        <Row>
                          <Col
                            xs={12}
                            md={6}
                            className="d-flex align-items-center py-1"
                          ></Col>
                          <Col
                            xs={12}
                            md={6}
                            className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                          >
                            <Paginator.PaginationListStandalone
                              {...paginationProps}
                            />
                          </Col>
                        </Row>
                      </Card.Footer>
                    </div>
                  </Card>
                )}
              </Paginator.PaginationProvider>
            )}
          </ToolkitProvider>
        </>
      )}
    </>
  );
};
